import { FCC } from "@/types/common";
import { InnerBox } from "@/components/elements/InnerBox";
import { Textarea } from "@/components/elements/Textarea";
import { FormField } from "@/components/elements/FormField";
import { Typography } from "@mui/material";
import { Control, useWatch } from "react-hook-form";
import { TCaseBasicInfo } from "@/features/case/types/case";
import { FocusEvent, useCallback } from "react";

type CaseMemoFieldProps = {
  control: Control<TCaseBasicInfo>;
  disabled?: boolean;
  mt?: number;
  mb?: number;
  onBlur?: (newMemo: string | null | undefined) => void;
};

export const CaseMemoField: FCC<CaseMemoFieldProps> = ({ control, disabled = false, mt = 3, mb = 3, onBlur }) => {
  const memoValue = useWatch({ control, name: "memo" });

  const handleBlur = useCallback(
    (e: FocusEvent<HTMLTextAreaElement>) => {
      if (onBlur) {
        onBlur(e.target.value || memoValue);
      }
    },
    [onBlur, memoValue],
  );

  return (
    <InnerBox mt={mt} mb={mb} showDivider={false} title={<Typography variant="sub16Bold">案件メモ</Typography>}>
      <FormField control={control} name="memo" noLabel>
        <Textarea disabled={disabled} onBlur={handleBlur} />
      </FormField>
    </InnerBox>
  );
};
